<!--
/**
* @description:账户审核
* @author: 张伟
* @time: 2022-04-07 11:01:55
*/
-->
<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false" gutter="10px">
      <y-query-item>
        <k-input placeholder="请输入账户审核编号" v-model="para.id" clearable></k-input>
      </y-query-item>
      <y-query-item>
        <k-input placeholder="请输入分销员名称关键词" v-model="para.accountName" clearable></k-input>
      </y-query-item>
      <y-query-item>
        <DatePicker :editable="false" type="datetimerange" @on-change="onChangeDate" :value="[para.startTime,para.endTime]"
                    format="yyyy-MM-dd HH:mm:ss"
                    placeholder="请选择创建时间 " style="width: 280px;"></DatePicker>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择状态" v-model="para.status" clearable>
          <k-option v-for="(item,index) in auditStatus" :key="index" :selected="para.status === item.value"
                    :value="item.value" :label="item.label">{{ item.label }}
          </k-option>
        </k-select>
      </y-query-item>
      <y-query-item slot="right">
        <k-button type="primary" @click="onSearch">查询</k-button>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
    </y-query>
    <k-table :data="list" :pageIndex="para.pageCurrent" :pageSize="para.pageSize" :height="$root.tableHeightX"
             :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" v-if="list && list.length" :current-page.sync="para.pageCurrent"
                  :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
    <!-- 日志弹框-->
    <k-popup :show.sync="isShowLogPopup" title="审核日志" layout="header,body,close,mask">
      <y-popup-body size="big">
        <div class="mb-2" style="min-height: 300px;">
          <k-table :data="logList" :columns="logColumns"></k-table>
        </div>
      </y-popup-body>
    </k-popup>
    <!--图片上传弹框-->
    <k-popup :show.sync="isShowUploadPopup" title="上传委托收款函" okText="保存" @after-ok="saveImg">
      <y-popup-body>
        <div :class="css.upload_content">
          <div>委托收款函：</div>
          <div>
            <div class="row">
              <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploaded"
                             acceptType="image/jpg,image/jpeg,image/png"></y-upload-file>
              <y-image @delete="onDelete1Img" v-dragging="{ list: imgList, item: img, group: 'image' }" v-for="(img, index) in imgList" :key="index"
                       :index="index" :src="img"></y-image>
            </div>
            <div class="mt-1" style="color: #bfbfbf;">仅支持jpg/png，最多上传1张，大小不超过3M</div>
          </div>
        </div>
      </y-popup-body>
    </k-popup>
  </y-view>
</template>

<script>
import {
  NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_BANK_AUDIT_INDEX,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_BANK_AUDIT_LOGS,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_BANK_AUDIT_OPERATOR,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_BANK_AUDIT_STATUS
} from "@/assets/modules/apiList";

export default {
  name: "accountAuditList",
  data() {
    return {
      isLoading: false,
      list: [ {} ],//列表数据
      logList: [],//日志列表数据
      isShowLogPopup: false, //日志弹框
      isShowUploadPopup: false, //上传弹框
      uploadUrl: NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
      currentUploadId: '',//当前上传委托函的记录id
      imgList: [],//上传图片展示列表
      total: 0,//总条数
      para: {
        pageCurrent: 1,
        pageSize: 20,
        id: '',
        accountName: '',
        startTime: '',
        endTime: '',
        status: '',
      },
      auditStatus: [],
    }
  },
  created() {
    this.getList();
    this.getStatusList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getList();
    next();
  },
  methods: {
    //获取列表数据
    getList() {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_BANK_AUDIT_INDEX,
        para: this.para
      }).then(res => {
        this.list = res.pageList;
        this.total = res.total;
        this.isLoading = false;
      });
    },
    //获取日志数据
    getLogList(id) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_BANK_AUDIT_LOGS,
        para: { id }
      }).then(res => {
        this.isLoading = false;
        this.logList = res;
        this.isShowLogPopup = true;
      });
    },
    getStatusList() {
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_BANK_AUDIT_STATUS
      }).then(res => {
        Object.keys(res).forEach(item => {
          this.auditStatus.push({ label: res[item], value: item })
        })
      });
    },
    //图片上传成功
    onUploaded(res) {
      this.imgList = [ res.data[0].url ];
    },
    //删除上传图片
    onDelete1Img(obj) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.imgList.splice(obj.index, 1);
        },
      });
    },
    //保存委托函
    saveImg() {
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_BANK_AUDIT_OPERATOR,
        para: { id: this.currentUploadId, action: 'letter', value: this.imgList[0] }
      }).then(res => {
        this.$root.tip('委托收款函修改成功', 'success');
        this.isShowUploadPopup = false;
      });
    },
    onChangePageIndex(page) {
      this.para.pageCurrent = page;
      this.getList();
    },
    //表格样式
    style(w = 120) {
      return {
        width: w,
        'text-align': 'center',
        'white-space': 'normal',
        'word-break': 'break-all'
      }
    },
    //查询按钮
    onSearch() {
      this.para.pageCurrent = 1;
      this.getList();
    },
    //重置按钮
    onReset() {
      this.para = this.$options.data().para;
      this.getList();
    },
    //选择日期
    onChangeDate(date) {
      this.para.startTime = date[0];
      this.para.endTime = date[1] ? date[1].split(' ')[0] + ' 23:59:59' : '';
    },
    //表格列数据
    initColumns() {
      return [
        { name: '创建时间', field: 'createTime', style: this.style() },
        { name: '分销员名称', field: 'accountName', style: this.style() },
        { name: '分销员账号', field: 'accountNo', style: this.style() },
        { name: '账户审核编号', field: 'id', style: this.style() },
        { name: '分销角色', field: 'roleName', style: this.style() },
        { name: '状态', field: 'statusName', style: this.style() },
        {
          name: '操作', style: this.style(150), customRender: (row) => (
            <div style="display: flex;justify-content: space-around;">
              {row.status == '0' && <a href="javascript:void(0)" onClick={() => {
                this.$controller.open({
                  name: "auditDetail",
                  query: {
                    refresh: new Date() - 0,
                    id: row.id
                  },
                  title: "平台审核",
                });
              }}>平台审核</a>}
              {row.status == '0' && <a href="javascript:void(0)" onClick={() => {
                this.imgList = [];
                this.isShowUploadPopup = true;
                this.currentUploadId = row.id;
              }}>上传委托收款函</a>}
              <a href="javascript:void(0)" onClick={() => {
                this.getLogList(row.id);
              }}>日志</a>
            </div>
          )
        },
      ]
    },
    logColumns() {
      return [
        { name: "创建时间", field: "createTime", style: this.style(), },
        { name: "创建人", field: "createdBy", style: this.style(), },
        { name: "操作", field: "description", style: this.style(), },
        { name: "内容", field: "content", style: this.style(), },
        { name: "备注", field: "remark", style: this.style(), }
      ]
    }
  }
}
</script>

<style lang="postcss" module="css">
.upload_content {
  display: flex;
  align-items: flex-start;
}
</style>
